import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { numberWithCommas } from "@/helpers/Helpers";
export default function WaveHeaderFollowers(t0) {
  const $ = _c(10);
  const {
    wave,
    onFollowersClick
  } = t0;
  let t1;
  if ($[0] !== wave.metrics.subscribers_count) {
    t1 = numberWithCommas(wave.metrics.subscribers_count);
    $[0] = wave.metrics.subscribers_count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="tw-font-medium tw-text-iron-50">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-text-iron-400">Joined</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <span>{t2}{" "}{t3}</span>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onFollowersClick || $[8] !== t4) {
    t5 = <button onClick={onFollowersClick} className="tw-p-0 tw-bg-transparent tw-border-none tw-text-sm tw-flex tw-items-center tw-gap-x-2 hover:tw-underline tw-transition tw-duration-300 tw-ease-out">{t4}</button>;
    $[7] = onFollowersClick;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}